module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("Hello " + _vm._s(_vm.username) + ",")]), _vm._v(" "), _c('h3', [_vm._v("Let everyone know you're online and working.")]), _vm._v(" "), _c('div', {
    staticClass: "m-t-md m-b-md"
  }, [_c('div', [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.signInToSlack($event)
      }
    }
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Reason (Optional)")]), _vm._v(" "), (_vm.typedreason) ? _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formReason),
      expression: "formReason"
    }],
    staticClass: "input form-control m-b-sm",
    attrs: {
      "type": "text",
      "placeholder": "Add a reason"
    },
    domProps: {
      "value": (_vm.formReason)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.formReason = $event.target.value
      }
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "centered text-sm text-u-l",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.existingReason($event)
      }
    }
  }, [_vm._v("Use an existing reason?")])]) : _vm._e(), _vm._v(" "), (_vm.existing) ? _c('p', {
    staticClass: "control"
  }, [_c('v-select', {
    staticClass: "m-b-sm",
    attrs: {
      "value": _vm.formReason,
      "options": _vm.existingReasons
    },
    on: {
      "update:value": function($event) {
        _vm.formReason = $event
      }
    },
    model: {
      value: (_vm.formReason),
      callback: function($$v) {
        _vm.formReason = $$v
      },
      expression: "formReason"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "centered text-sm text-u-l",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.typedReason($event)
      }
    }
  }, [_vm._v("Type in a new reason?")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-primary is-large centered kuzco-green",
    class: {
      'is-disabled': _vm.disabled
    }
  }, [_vm._v("Sign In\n            "), _c('span', {
    class: {
      'slack-loader': _vm.loading
    }
  })])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-812c0ec2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Signin.vue
// module id = 388
// module chunks = 1